import { StyleSheet, Dimensions } from 'react-native'
import theme from './theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#FFFFFF',
    },
    containerLoader: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'black',
        opacity: 0.5,
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerLoaderWhite: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        opacity: 1,
        pointerEvents: 'none',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerGif: {
        flex: 1,
        backgroundColor: 'white',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    loaderText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        lineHeight: 22,
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 20,
        paddingHorizontal: 35,
    },
    splashContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    splashgif: {
        width: '100%',
        height: 170,
    },
    claimContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        width: width / 2,
    },
    claimText: {
        color: theme.colors.textSecondary,
        fontSize: 14,
        textAlign: 'center',
    },
})

export default styles
